'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseApi = require('./base_api');

var UnloadApi = function (_BaseApi) {
  _inherits(UnloadApi, _BaseApi);

  function UnloadApi() {
    _classCallCheck(this, UnloadApi);

    return _possibleConstructorReturn(this, (UnloadApi.__proto__ || Object.getPrototypeOf(UnloadApi)).apply(this, arguments));
  }

  _createClass(UnloadApi, [{
    key: 'init',
    value: function init(options) {
      this.transmitter.messageToEmarsys('unload:init', options);
    }
  }, {
    key: 'reset',
    value: function reset(selector) {
      this.transmitter.messageToEmarsys('unload:reset', {
        selector: selector
      });
    }
  }], [{
    key: 'create',
    value: function create(transmitter) {
      var api = new UnloadApi(transmitter);

      return api.exposeMethods(['init', 'reset']);
    }
  }]);

  return UnloadApi;
}(BaseApi);

module.exports = UnloadApi;


/*****************
 ** WEBPACK FOOTER
 ** /home/runner/work/emarsys-integration-js/emarsys-integration-js/~/emarsys-integration-client/dist/client/unload_api.js
 ** module id = 9
 ** module chunks = 0 1
 **/